import { string,email} from "../Rules";
import * as Yup from "yup";

export const VerifyValidationLogin = Yup.object().shape({

  username: email("username", true),
  password: string("password", true),

});
